export enum ExtendedContentItemTitleEnum {
  Provider = 'PROVIDER',
  Year = 'YEAR',
  Product = 'PRODUCT',
  Category = 'CATEGORY',
}
